/**
 * @fileoverview POST handler for bulk updating workspace time zones
 */
import fetch from "@lib/fetch";

export interface BulkSetWorkspaceTimezonesParams {
  workspace_updates: Array<{
    app_group_id: string;
    time_zone: string | null;
  }>;
}

export const bulkSetWorkspaceTimezones = (params: BulkSetWorkspaceTimezonesParams): Promise<{}> => {
  return fetch("/companies/workspaces_time_zones/upsert", "POST", params);
};
